import React from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Linking,
} from "react-native";
import { Color, globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import EventChildComponent from "./EventChildComponent";
import SettlementLink from "./SettlementLink";
import { openURL, trackMoengageEvent } from "../../../utils/commonMethods";
import {globalConfigurableData} from "../../../utils/globalConstant";
import FormTextLabel from "../../../commonComponents/FormTextLabel";

const MarketResolution = ({ resolutionData, source, full_rules }) => {
  const linkRedirection = (link) => {
    trackMoengageEvent("Source Of Settlement");
    openURL(link);
  };

  return (
    <View style={styles.container}>
      <Text
        style={[globalFontStyle.appFontSubText, styles.resolutionText]}
      >
        {resolutionData}
      </Text>
      {source ? (
        <View style={styles.sourceLinkContainer}>
          <Text style={styles.sourceLinkLabel}>
            Source Settlement Link:
          </Text>
          <Text
            onPress={() => linkRedirection(source)}
            style={[
              globalFontStyle.appFontSubTextBold,
              styles.sourceLink,
            ]}
          >
            {source && source.split("/").slice(0, 3).join("/")}
          </Text>
        </View>
      ) : null}
      {full_rules ? (
        <View style={styles.buttonContainer}>
          <TouchableOpacity 
            onPress={() => linkRedirection(full_rules)}
            style={styles.button}
          >
            <FormTextLabel
              labelStyles={styles.buttonText}
              label={"View Full Rules"} 
            />
          </TouchableOpacity>
          <View style={{ flex: 1 }} />
        </View>
      ) : null}
    </View>
  );
};

export default MarketResolution;

const styles = StyleSheet.create({
  container: {
    paddingVertical: 16,
  },
  resolutionText: {
    color: globalConfigurableData.secondaryTextColor1,
    marginBottom: 12,
    lineHeight: 20,
  },
  sourceLinkContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 8,
    marginBottom: 16,
  },
  sourceLinkLabel: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.secondaryTextColor1,
    marginRight: 4,
  },
  sourceLink: {
    color: globalConfigurableData.primaryTextColor1,
    textDecorationLine: "underline",
  },
  buttonContainer: {
    flexDirection: "row",
    marginTop: 8,
  },
  button: {
    borderWidth: 1,
    borderColor: "#000000",
    borderRadius: 5,
  },
  buttonText: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.primaryTextColor1,
    paddingHorizontal: 15,
    paddingVertical: 10,
  },
});
